import { PUBLISH_CAMPAIGN } from './action-types';

export default Object.freeze({
  [PUBLISH_CAMPAIGN]: {
    'campaign.error.validation.coverImage.INVALID_URL':
      'Invalid url for campaign image',
  },
});
